import { render, staticRenderFns } from "./POIGeneralStateField.vue?vue&type=template&id=0629a45a"
import script from "./POIGeneralStateField.js?vue&type=script&lang=js&external"
export * from "./POIGeneralStateField.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports